var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglebooks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.723,
    height: 103.825,
    id: "google-play-books",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1768a4",
    d: "M0 2.229A2.271 2.271 0 0 1 1.089.287a2.322 2.322 0 0 1 2.236 0L89.6 49.606a2.214 2.214 0 0 1 1.118 1.913 2.155 2.155 0 0 1-1.118 1.913L3.8 103.516a2.178 2.178 0 0 1-2.236 0 2.214 2.214 0 0 1-1.118-1.913Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e94d1",
    d: "M30.427 16.883c0-.235-.029-.441-.088-.441H15.772c-.059 0-.088.206-.088.441v78.57c0 .235.029.441.088.441h1.089l13.536-7.916v-71.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28.353 14.363h48.236v75.144H28.353z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61cbee",
    d: "M75.068 61.936V16.884c0-.235-.147-.441-.294-.441h-9.976v12.212l-4.326-2.089-4.62 2.089V16.413h-25.16c-.177 0-.294.206-.294.441v71.125l44.67-26.043Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M54.391 14.951h12.501V30.7H54.391z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m60.472 26.535 4.326 2.089V16.412h-8.946v12.212Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglebooks);
export default __webpack_public_path__ + "static/media/Google books.1ac3c572c92e392c465253a93cd9d1e9.svg";
export { ForwardRef as ReactComponent };